// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let ConversationsSectionCommon_InitiatePropertyConversationMutation_graphql = require("../../../__generated__/ConversationsSectionCommon_InitiatePropertyConversationMutation_graphql.bs.js");
let ConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql = require("../../../__generated__/ConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql.bs.js");
let ConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql = require("../../../__generated__/ConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql.bs.js");
let ConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql = require("../../../__generated__/ConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.bs.js");
let ConversationsSectionCommon_InitiateDevelopmentProjectConversationMutation_graphql = require("../../../__generated__/ConversationsSectionCommon_InitiateDevelopmentProjectConversationMutation_graphql.bs.js");
let ConversationsSectionCommon_InitiateDevelopmentSampleUnitConversationMutation_graphql = require("../../../__generated__/ConversationsSectionCommon_InitiateDevelopmentSampleUnitConversationMutation_graphql.bs.js");

let convertVariables = ConversationsSectionCommon_InitiatePropertyConversationMutation_graphql.Internal.convertVariables;

let convertResponse = ConversationsSectionCommon_InitiatePropertyConversationMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = ConversationsSectionCommon_InitiatePropertyConversationMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ConversationsSectionCommon_InitiatePropertyConversationMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, ConversationsSectionCommon_InitiatePropertyConversationMutation_graphql.node, convertResponse, convertWrapRawResponse);

let InitiatePropertyConversationMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertVariables$1 = ConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.Internal.convertVariables;

let convertResponse$1 = ConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = ConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, ConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, ConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let InitiateMessageBroadcastConversationMutation_conversationVisibilityV5_decode = ConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.Utils.conversationVisibilityV5_decode;

let InitiateMessageBroadcastConversationMutation_conversationVisibilityV5_fromString = ConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.Utils.conversationVisibilityV5_fromString;

let InitiateMessageBroadcastConversationMutation = {
  conversationVisibilityV5_decode: InitiateMessageBroadcastConversationMutation_conversationVisibilityV5_decode,
  conversationVisibilityV5_fromString: InitiateMessageBroadcastConversationMutation_conversationVisibilityV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$1
};

let convertVariables$2 = ConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql.Internal.convertVariables;

let convertResponse$2 = ConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$2 = ConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$2 = RescriptRelay_Mutation.commitMutation(convertVariables$2, ConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables$2, ConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let InitiateRentalNeedConversationMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  commitMutation: commitMutation$2,
  use: use$2
};

let convertVariables$3 = ConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql.Internal.convertVariables;

let convertResponse$3 = ConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$3 = ConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$3 = RescriptRelay_Mutation.commitMutation(convertVariables$3, ConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

let use$3 = RescriptRelay_Mutation.useMutation(convertVariables$3, ConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

let InitiateBuyerNeedConversationMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$3,
  convertResponse: convertResponse$3,
  convertWrapRawResponse: convertWrapRawResponse$3,
  commitMutation: commitMutation$3,
  use: use$3
};

let convertVariables$4 = ConversationsSectionCommon_InitiateDevelopmentProjectConversationMutation_graphql.Internal.convertVariables;

let convertResponse$4 = ConversationsSectionCommon_InitiateDevelopmentProjectConversationMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$4 = ConversationsSectionCommon_InitiateDevelopmentProjectConversationMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$4 = RescriptRelay_Mutation.commitMutation(convertVariables$4, ConversationsSectionCommon_InitiateDevelopmentProjectConversationMutation_graphql.node, convertResponse$4, convertWrapRawResponse$4);

let use$4 = RescriptRelay_Mutation.useMutation(convertVariables$4, ConversationsSectionCommon_InitiateDevelopmentProjectConversationMutation_graphql.node, convertResponse$4, convertWrapRawResponse$4);

let InitiateDevelopmentProjectConversationMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$4,
  convertResponse: convertResponse$4,
  convertWrapRawResponse: convertWrapRawResponse$4,
  commitMutation: commitMutation$4,
  use: use$4
};

let convertVariables$5 = ConversationsSectionCommon_InitiateDevelopmentSampleUnitConversationMutation_graphql.Internal.convertVariables;

let convertResponse$5 = ConversationsSectionCommon_InitiateDevelopmentSampleUnitConversationMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$5 = ConversationsSectionCommon_InitiateDevelopmentSampleUnitConversationMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$5 = RescriptRelay_Mutation.commitMutation(convertVariables$5, ConversationsSectionCommon_InitiateDevelopmentSampleUnitConversationMutation_graphql.node, convertResponse$5, convertWrapRawResponse$5);

let use$5 = RescriptRelay_Mutation.useMutation(convertVariables$5, ConversationsSectionCommon_InitiateDevelopmentSampleUnitConversationMutation_graphql.node, convertResponse$5, convertWrapRawResponse$5);

let InitiateDevelopmentSampleUnitConversationMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$5,
  convertResponse: convertResponse$5,
  convertWrapRawResponse: convertWrapRawResponse$5,
  commitMutation: commitMutation$5,
  use: use$5
};

function attachmentToInput(attachment) {
  return {
    contentType: attachment.contentType,
    fileName: attachment.fileName,
    id: attachment.id,
    key: attachment.key
  };
}

exports.InitiatePropertyConversationMutation = InitiatePropertyConversationMutation;
exports.InitiateMessageBroadcastConversationMutation = InitiateMessageBroadcastConversationMutation;
exports.InitiateRentalNeedConversationMutation = InitiateRentalNeedConversationMutation;
exports.InitiateBuyerNeedConversationMutation = InitiateBuyerNeedConversationMutation;
exports.InitiateDevelopmentProjectConversationMutation = InitiateDevelopmentProjectConversationMutation;
exports.InitiateDevelopmentSampleUnitConversationMutation = InitiateDevelopmentSampleUnitConversationMutation;
exports.attachmentToInput = attachmentToInput;
/* commitMutation Not a pure module */
